import React, { useState } from 'react';
import './SeriesScopeDialog.css';

export type SeriesScope = 'this' | 'future' | 'all';

interface SeriesScopeDialogProps {
  action: 'edit' | 'delete';
  open: boolean;
  onCancel: () => void;
  onConfirm: (scope: SeriesScope) => void;
}

const SeriesScopeDialog: React.FC<SeriesScopeDialogProps> = ({
  action,
  open,
  onCancel,
  onConfirm,
}) => {
  const [scope, setScope] = useState<SeriesScope>('this');

  if (!open) return null;

  const verb = action === 'edit' ? 'Save changes to' : 'Delete';
  const cta = action === 'edit' ? 'Save' : 'Delete';

  return (
    <div className="series-scope-overlay" onClick={onCancel}>
      <div className="series-scope-dialog" onClick={(e) => e.stopPropagation()}>
        <h3>{action === 'edit' ? 'Edit recurring banner' : 'Delete recurring banner'}</h3>
        <p className="series-scope-subtitle">
          This banner is part of a recurring series. {verb}:
        </p>

        <label className="series-scope-option">
          <input
            type="radio"
            name="series-scope"
            value="this"
            checked={scope === 'this'}
            onChange={() => setScope('this')}
          />
          <span>
            <strong>Just this banner</strong>
            <span className="series-scope-hint">Other instances are unaffected.</span>
          </span>
        </label>

        <label className="series-scope-option">
          <input
            type="radio"
            name="series-scope"
            value="future"
            checked={scope === 'future'}
            onChange={() => setScope('future')}
          />
          <span>
            <strong>This and future banners</strong>
            <span className="series-scope-hint">Past instances stay as-is.</span>
          </span>
        </label>

        <label className="series-scope-option">
          <input
            type="radio"
            name="series-scope"
            value="all"
            checked={scope === 'all'}
            onChange={() => setScope('all')}
          />
          <span>
            <strong>All banners in the series</strong>
            <span className="series-scope-hint">Including past instances.</span>
          </span>
        </label>

        <div className="series-scope-actions">
          <button type="button" className="series-scope-cancel" onClick={onCancel}>
            Cancel
          </button>
          <button
            type="button"
            className={`series-scope-confirm ${action === 'delete' ? 'destructive' : ''}`}
            onClick={() => onConfirm(scope)}
          >
            {cta}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SeriesScopeDialog;
